/**
 * 报关贴纸管理- 报关品名进度跟踪
 *
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2021, all rights reserved. Essa.cn
 */
import React from 'react';
import {  Spin,} from "antd";
import CommonBreadcrumb from "@components/CommonBreadcrumb";
import Lang from "@/components/Lang/Lang";
import AutoFetchTable from "@/components/AutoFetchTable/AutoFetchTable";
import CopyInput from "@components/CopyAndPaste/CopyInput";
import dayjs from 'dayjs';
import "./List.less";
class CustomsCoding extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            searchFormOptions:[
                {
                    name:'mobile',
                    cnTitle:'手机号',
                    cnTitleId:'ShouJiHao',
                },
            ],
            columns:[
                {
                    cnTitle: '手机号',
                    cnTitleId: 'ShouJiHao',
                    dataIndex: 'mobile',
                    render: (mobile, record) => {
                        return(<div className={"fw_700 black89"}>
                            {mobile}
                        </div>)}
                },
                {
                    cnTitle: '验证码',
                    cnTitleId: 'YanZhengMa',
                    dataIndex: 'verificationCode',
                    render: (verificationCode, record) => {
                        return(<div className={"color-blue cursor-p"}>
                            {verificationCode&&<CopyInput value={verificationCode} optionId={'code_input_copy_'+verificationCode} >{verificationCode}</CopyInput>}
                        </div>)}
                },
                {
                    cnTitle: '发送时间',
                    cnTitleId: 'FaSongShiJian',
                    dataIndex: 'createTime',
                    render: (createTime, record) => createTime?dayjs(createTime).format('YYYY-MM-DD HH:mm:ss'):'-'
                },

                {
                    cnTitle: '有效至',
                    cnTitleId: 'YouXiaoZhi',
                    dataIndex: 'effectiveTime',
                    render: (effectiveTime, record) => effectiveTime?dayjs(effectiveTime).format('YYYY-MM-DD HH:mm:ss'):'-'
                },
            ],
        }
    }
    render(){
        const { loading,searchFormOptions,columns, } = this.state;

        const currPageName = Lang({id: "DuanXinYanZhengMa",default: "短信验证码"});
        return (<Spin tip='loading' spinning={loading}>
                <CommonBreadcrumb list={[{ name:currPageName}]}></CommonBreadcrumb>
                <div className={'progressTrackingList'}>
                    <div className={'title fw_700 font_18'}>{currPageName}</div>
                    <AutoFetchTable columns={columns}
                                    flagShowReset={false}
                                    rowKey={"createTime"}
                                    searchFormOptions={searchFormOptions}
                                    fetchApi={'/service/mg/follower/verification-code-list'} />
                </div>
            </Spin>

        )
    }
}

export default CustomsCoding;
